export const COUNTRIES = [
  "Jamaica",
  "Canada",
  "China",
  "United States",
  "Barbados",
  "Trinidad and Tobago",
  "Cayman Islands",
  "United Kingdom",
  "Bahamas",
  "Guyana",
  "Panama",
  "Brazil",
  "Argentina",
  "Venezuela",
  "Mexico",
  "Haiti",
  "Other",
];

export const CARGO_TYPES = [
  "General Goods",
  "Perishables",
  "Controlled/Regulated Goods",
  "Oversized/Heavy Freight",
  "Other",
];

export const TRADE_LANE_PINS = [
  {
    id: "kingston",
    name: "Kingston, Jamaica",
    status: "active",
    label: "HEADQUARTERS",
    tooltip: "Kingston, Jamaica — Headquarters — 30 years serving Caribbean, North American, South American, African, and Asian trade corridors.",
    lane: "30 years serving Caribbean, North American, South American, African, and Asian trade corridors.",
    lat: 17.9714,
    lon: -76.7920,
  },
  {
    id: "toronto",
    name: "Toronto, Canada",
    status: "soon",
    label: "COMING SOON",
    lane: "Canada to Jamaica: air freight and consolidation corridor.",
    lat: 43.6532,
    lon: -79.3832,
  },
  {
    id: "shanghai",
    name: "Shanghai, China",
    status: "soon",
    label: "COMING SOON",
    lane: "China to Jamaica: full container, LCL, air freight.",
    lat: 31.2304,
    lon: 121.4737,
  },
  {
    id: "miami",
    name: "Miami, USA",
    status: "soon",
    label: "COMING SOON",
    lane: "USA to Jamaica: door-to-door sea and air freight.",
    lat: 25.7617,
    lon: -80.1918,
  },
  {
    id: "barbados",
    name: "Barbados",
    status: "soon",
    label: "COMING SOON",
    lane: "Caribbean region: CARICOM regional trade corridor.",
    lat: 13.1939,
    lon: -59.5432,
  },
  {
    id: "panama",
    name: "Panama City, Panama",
    status: "soon",
    label: "COMING SOON",
    lane: "Panama Canal corridor, transshipment hub.",
    lat: 8.9936,
    lon: -79.5197,
  },
  {
    id: "guyana",
    name: "Guyana (Georgetown)",
    status: "soon",
    label: "COMING SOON",
    lane: "Caribbean coast cargo, bulk commodities.",
    lat: 6.8013,
    lon: -58.1551,
  },
  {
    id: "brazil",
    name: "Brazil (Santos)",
    status: "soon",
    label: "COMING SOON",
    lane: "South America to Caribbean, container and LCL.",
    lat: -23.9608,
    lon: -46.3336,
  },
  {
    id: "argentina",
    name: "Argentina (Buenos Aires)",
    status: "soon",
    label: "COMING SOON",
    lane: "South Atlantic corridor, refrigerated and general cargo.",
    lat: -34.6037,
    lon: -58.3816,
  },
  {
    id: "venezuela",
    name: "Venezuela (La Guaira)",
    status: "soon",
    label: "COMING SOON",
    lane: "Caribbean regional freight.",
    lat: 10.6010,
    lon: -66.9336,
  },
  {
    id: "mexico",
    name: "Mexico (Veracruz)",
    status: "soon",
    label: "COMING SOON",
    lane: "Gulf of Mexico corridor, manufacturing goods.",
    lat: 19.1738,
    lon: -96.1342,
  },
  {
    id: "nigeria",
    name: "Lagos, Nigeria",
    status: "soon",
    label: "COMING SOON",
    lane: "West Africa corridor, Transatlantic container and bulk cargo.",
    lat: 6.5244,
    lon: 3.3792,
  },
];

export const COMMON_VESSELS = [
  "MSC OSCAR",
  "EVER GIVEN",
  "MAERSK GIBRALTAR",
  "CMA CGM MARCO POLO",
  "COSCO SHIPPING UNIVERSE",
  "HMM ALGECIRAS",
  "ONE INNOVATION",
  "EVERGREEN EVER GOLDEN",
  "ZIM TRIUMPH",
  "SEABOARD MARINER",
  "JAMAICA PRODUCER",
  "CROWLEY CARIBBEAN",
  "TROPICAL SHIPPING EXPRESS",
  "GEEST LINE CARIBBEAN",
  "MSC CARIBBEAN",
  "MAERSK PATRAS",
  "ATLANTIC ROSE",
  "KINGSTON EXPRESS",
  "CARIBBEAN PRINCESS",
  "ADVENTURE OF THE SEAS",
  "OASIS OF THE SEAS",
  "CARNIVAL SUNRISE",
  "DISNEY FANTASY",
  "NORWEGIAN GETAWAY",
];

export const RESOURCE_LINKS = [
  {
    name: "Jamaica Customs Agency",
    desc: "Official tariffs, import/export procedures, and regulatory notices for Jamaica.",
    url: "https://www.jacustoms.gov.jm",
  },
  {
    name: "CARICOM Secretariat",
    desc: "Caribbean Community trade rules, the CARICOM Single Market and regional agreements.",
    url: "https://caricom.org",
  },
  {
    name: "Canada Border Services Agency (CBSA)",
    desc: "Canadian import/export regulations, tariffs, and customs procedures.",
    url: "https://www.cbsa-asfc.gc.ca",
  },
  {
    name: "U.S. Customs and Border Protection (CBP)",
    desc: "United States import requirements, duties, and cargo clearance rules.",
    url: "https://www.cbp.gov",
  },
  {
    name: "China Customs (GACC)",
    desc: "General Administration of Customs of the People's Republic of China.",
    url: "http://english.customs.gov.cn",
  },
  {
    name: "World Customs Organization",
    desc: "Global customs standards, harmonized tariff classifications, and compliance frameworks.",
    url: "https://www.wcoomd.org",
  },
];
